import React from "react";
import { useNavigate } from "react-router-dom";
import { useLocalization } from "../../context/LocalizationContext";
import Header from "../shared/Header";
import HomeIcon from "../../assets/icons/home.svg";
import "./ChatManager.css";
import TawuniyaIcon from "../../assets/icons/tawwnya.svg";
import QrCode from "../../assets/icons/qr.svg";

const ChatManager = ({ userData }) => {
  const navigate = useNavigate();
  const { t, isRTL } = useLocalization();

  return (
    <div className="main-container">
      <Header text={t("chatManager.title")} userData={userData} />

      <div className="assessment-content">
        <div className="description-container">
          {t("chatManager.instruction")}
        </div>

        <div className="qr-code-container">
          <div className="qr-card">
            <div className="qr-header">
              <div className="tawuniya-icon">
                <img src={TawuniyaIcon} alt="Tawuniya" />
              </div>
              <h3 className="qr-title">{t("chatManager.title")}</h3>
            </div>

            <div className="qr-code-wrapper">
              <div className="qr-code">
                <img src={QrCode} alt="QR Code" />
              </div>
            </div>
          </div>
        </div>

        <div className="assessment-footer">
          <button
            className="footer-btn home-btn"
            onClick={() => navigate("/dashboard")}
          >
            <img src={HomeIcon} alt="Home" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default ChatManager;
